import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { StyledFooter } from "./styles";
var MenuItem = function(_param) {
    var items = _param.items, isDark = _param.isDark, toggleTheme = _param.toggleTheme, currentLang = _param.currentLang, langs = _param.langs, setLang = _param.setLang, cakePriceUsd = _param.cakePriceUsd, buyCakeLabel = _param.buyCakeLabel, props = _object_without_properties(_param, [
        "items",
        "isDark",
        "toggleTheme",
        "currentLang",
        "langs",
        "setLang",
        "cakePriceUsd",
        "buyCakeLabel"
    ]);
    var frameFooterStyle = {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: "16px"
    };
    var groupStyle = {
        flex: "1 1 150px",
        display: "flex",
        justifyContent: "center"
    };
    var imgStyle = {
        maxWidth: "100%",
        height: "auto"
    };
    var openInNewTab = function(url) {
        window.open(url, "_blank", "noopener,noreferrer");
    };
    return /*#__PURE__*/ _jsx(StyledFooter, {
        children: /*#__PURE__*/ _jsx("div", {
            style: {
                width: "100%",
                background: "#101010"
            },
            children: /*#__PURE__*/ _jsx("div", {
                className: "frame_footer frame_footers",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "group-iEyiFd group-iEyiFds",
                    style: {
                        width: "100%",
                        textAlign: "center"
                    },
                    children: /*#__PURE__*/ _jsx("span", {
                        style: {
                            lineHeight: "100px",
                            color: "#5E6B7E"
                        },
                        children: "\xa9 2023 @ Boost your PNC mining profits today with DPoS. Get started now!"
                    })
                })
            })
        })
    });
};
export default MenuItem;
